import { useState } from 'react';
import { useAuth } from '@/context/AuthContext';
import { useNavigate } from 'react-router-dom';
import './Login.css';

// main login page component
export default function LoginPage() {
  // stores the username that the user enters 
  const [username, setUsername] = useState('');
  // stores the password that the user enters 
  const [password, setPassword] = useState('');
  // stores error messages
  const [error, setError] = useState('');
  // true when attempting login (shows "loading...")
  const [isLoading, setIsLoading] = useState(false);

  const { login } = useAuth();

  const navigate = useNavigate();
  
  const handleSubmit = async () => {
    // if username/passwd is empty, doesn't attempt to login
    if (!username || !password) {
      setError('Please enter username and password');
      return;
    }

    // clear error messages
    setError('');
    setIsLoading(true);
    
    try {
      await login(username, password);
    } catch (err: any) {
      // if login failed, show error
      setError('Invalid username or password');
    } finally {
      // always stop loading state when done
      setIsLoading(false);
    }
  };
  
// allows pressing enter to submit instead of clicking button
const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
    handleSubmit();
    }
  };
  
  // render the login page UI
  return (
    <div className="login-container">
      <div>
        <h1>AVANT-ELITIST</h1>
        <p>Sign in to continue</p>
        
        <div>
          <input
            type="text"
            placeholder="Username"
            value={username} // displays current state
            onChange={(e) => setUsername(e.target.value)} // updates state on change
            onKeyDown={handleKeyDown} // enables enter key submission
            disabled={isLoading} // disabled during login attempt
          />
          
          <input
            type="password" // masks input as dots/asterisks
            placeholder="Password"
            value={password} // controlled input - displays current state
            onChange={(e) => setPassword(e.target.value)} // updates state on change
            onKeyDown={handleKeyDown} // enables enter key submission
            disabled={isLoading} // disabled during login attempt
          />
          
          {error && <p>{error}</p>}
          
          <button 
            onClick={handleSubmit} // triggers login on click
            disabled={isLoading} // prevents multiple submissions
          >
            {isLoading ? 'Signing in...' : 'Sign In'}
          </button>

          <p>
            Don't have an account?{' '}
            <span onClick={() => navigate('/register')} className="switch-link">
              Sign up
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}
